import React from 'react'
import {Container, Row, Col, Button} from 'react-bootstrap'
import CartItem from './CartItem/CartItem';
import {Link} from 'react-router-dom'

const Cart = ({cart, handleUpdateCart, handleRemoveCart,handleEmptyCart}) => {

    const EmptyCart = () => (
        <p>No items in shopping cart. <Link to='/'>Start adding some!</Link></p>
    );

    const FilledCart = () => (
        <>
            <Row>
                {cart.line_items.map((item)=>(
                    <Col key={item.id} xs={12} sm={6} md={4} lg={3}>
                        <CartItem item={item}
                        handleUpdateCart={handleUpdateCart}
                        handleRemoveCart={handleRemoveCart}/>
                    </Col>
                ))}
            </Row>
            <Row>
            <div>
                <h4 className='mt-4 mb-4'>Subtotal: {cart.subtotal.formatted_with_symbol}</h4>
                <div className='mb-3' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button className='mr-4' variant="outline-secondary" onClick={()=>{handleEmptyCart()}}>Empty Cart</Button>
                    <Link to='/checkout'>
                    <Button variant="primary">Checkout</Button>
                    </Link>
                    
                </div>
            </div>
            </Row>
        </>
    );

    if(cart.total_items === undefined) return 'Loading...';

  return (
    <Container>
        <h2 className='mt-5 mb-3'>Your Shopping Cart</h2>
        {!cart.total_items ? <EmptyCart/> : <FilledCart/> }
    </Container>
  )
}

export default Cart
